module.exports = __webpack_public_path__ + "static/media/golfer-3-b.15489e14.png";